<template>
  <div>
    <h3 class="header-title">Learning Attendance</h3>
    <label>Let’s see your tuition student attendance.</label>
    <br />
    <div class="custom-explore">
      <div>
        <CRow>
          <CCol sm="12">
            <div style="width: 80%" class="float-left">
              <img
                src="../assets/img/iconnoti.svg"
                class="ml-5 mr-2 mb-3 mt-3"
              />
              <span class="text-white mt-3 mb-2"> | </span>
              <label class="ml-2 text-white mt-3 mb-2"
                >Explore more on your attendance student !</label
              >
            </div>
            <div style="width: 20%" class="float-right p-0">
              <br /><br />
              <img
                src="../assets/img/icontriangle.svg"
                class="ml-5 mr-2"
                style="
                  position: absolute;
                  top: 0;
                  right: 100px;
                  bottom: 0;
                  height: 55px;
                "
              />
            </div>
          </CCol>
        </CRow>
      </div>
    </div>
    <div v-if="Busy == true">
      <CCol sm="12" md="12">
        <div class="app flex-row align-items-center">
          <div class="container d-flex justify-content-center">
            <PulseLoader float />
          </div>
        </div>
      </CCol>
    </div>
    <div v-else>
      <CCol sm="12" class="mt-4">
        <CRow>
          <CCol sm="4">
            <CInput
              type="text"
              placeholder="Search text"
              v-model.lazy="SearchQuery"
              @change="ApplyFilter()"
            />
          </CCol>
        </CRow>

        <CRow>
          <CCol sm="3">
            <v-select
              v-model="selectedGrade"
              :options="gradeOptions"
              label="Class"
              class="custom-btn-blue style-chooser"
              @input="FilteredData()"
            ></v-select>
          </CCol>

          <CCol sm="3">
            <v-select
              v-model="selectedClass"
              :options="classOptions"
              label="Class"
              class="custom-btn-blue style-chooser"
              @input="FilteredData()"
            ></v-select>
          </CCol>
          <CCol sm="3">
            <v-select
              v-model="selectedTeacher"
              :options="teacherOptions"
              label="Teacher"
              class="custom-btn-blue style-chooser"
              @input="FilteredData()"
            ></v-select>
          </CCol>

          <CCol sm="3"> 
           

      <vue-json-to-csv
                    :json-data="attendanceReport"
                    :labels="{
                      refreshDate: {
                        title: 'Date of attendance taken',
                      },
                      subject: { title: 'SubjectName' },
                      teacher: {
                        title: 'Teacher',
                      },
                      name: { title: 'Student' },
                      attended: { title: 'Attend' },
                      TuitionCenterID : { title: 'TuitionCenterId' }
                    }"
                    @success="(val) => DownloadSuccess()"
                    @error="(val) => DownloadFail(val)"
                  >
                    <CButton color="info" class="mt-2 float-right"
                      >Download Report</CButton
                    >
                  </vue-json-to-csv>

          
          </CCol>
        </CRow>
      </CCol>
      <CCol sm="12">
        <CDataTable
          :bordered="bordered"
          :small="small"
          :fixed="fixed"
          :items="FilteredAttendance"
          :fields="fields"
          items-per-page-select
          :items-per-page="small ? 5 : 10"
          :dark="dark"
          clickable-rows
          sorter
          pagination
        >
          <template #Subject="{ item }">
            <td>
              <h6 style="color: #1e109c" class="text-uppercase">
                {{ item.SubjectName }}
              </h6>
              <div class="small text-muted">Grade : {{ item.Grade }}</div>
              <div class="small text-muted">Class : {{ item.Class }}</div>
            </td>
          </template>

          <template #Teacher="{ item }">
            <td>
              {{ item.Teacher }}
            </td>
          </template>

          <template #Date="{ item }">
            <td>
              {{ item.Date | moment("DD/MM/YYYY hh:mm A") }}
            </td>
          </template>
          <template #Action="{ item }">
            <td>
              <CDropdown
                toggler-text="Action"
                class="m-2 btn-act"
                color="primary"
              >
                <CDropdownItem @click="OpenStudentAttendance(item)"
                  >Edit</CDropdownItem
                >
              </CDropdown>
            </td>
          </template>
        </CDataTable>

        <CModal
          title="Student Attendance"
          size="md"
          :show.sync="AttendanceModal"
        >
          <div>
            <h6><strong>DETAIL ATTENDANCE</strong></h6>
            <br />
            <CCol sm="12">
              <CRow>
                Subject Name:

                <CCol sm="12">
                  <CDataTable
                    :small="small"
                    :fixed="fixed"
                    :items="FilteredSchedule"
                    :fields="fieldSchedule"
                    items-per-page-select
                    :items-per-page="small ? 5 : 5"
                    clickable-rows
                    pagination
                    sorter
                    table-filter
                  >
                    <template #Name="{ item }">
                      <td>
                        {{ item.Name }}
                      </td>
                    </template>

                    <template #Attended="{ item }">
                      <td>
                        <span v-if="item.Attended == true"
                          ><CBadge color="success">Yes</CBadge></span
                        >
                        <span v-else><CBadge color="danger">No</CBadge></span>
                      </td>
                    </template>
                    <template #Action="{ item }">
                      <td>
                        <CButton
                          type="button"
                          class="btn btn-success ml-3"
                          @click="UpdateAttendStudent(item)"
                        >
                          Yes</CButton
                        >
                        <CButton
                          type="button"
                          class="btn btn-danger ml-3"
                          @click="UpdateNotAttendStudent(item)"
                        >
                          No</CButton
                        >
                      </td>
                    </template>
                  </CDataTable>
                </CCol>
              </CRow>
            </CCol>
          </div>
          <template #footer>
            <CButton
              type="submit"
              class="p-2"
              color="info"
              @click="CloseModal()"
              >Proceed</CButton
            ></template
          >
        </CModal>
      </CCol>
    </div>
  </div>
</template>


<script>
import _ from "lodash";
import Vue from "vue";
Vue.use(require("vue-moment"));
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import $ from "jquery";

import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";

import VueJsonToCsv from "vue-json-to-csv";
import VuePapaParse from "vue-papa-parse";
Vue.use(VuePapaParse);

export default {
  name: "Tables",
  components: {
    PulseLoader,
    VueJsonToCsv,
  },
  data() {
    return {
      attendance: [],
      SearchQuery: "",
      FilteredAttendance: [],
      attendanceReport: [],

      selectedGrade: "ALL GRADE",
      gradeOptions: [],

      selectedClass: "ALL CLASS",
      classOptions: [],

      selectedTeacher: "ALL TEACHER",
      teacherOptions: [],

      Busy: false,

      fields: [
        { key: "Subject" },
        { key: "Teacher" },
        { key: "Date" },
        { key: "Action" },
      ],

      AttendanceModal: false,
      schedule: [],
      FilteredSchedule: [],
      fieldSchedule: [
        { key: "Name" },
        { key: "Attended" },
        { key: "Action" },
      ],
      BusyReport: false,
      OpenDownload: true,
    };
  },
  async mounted() {
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      await this.GetAttendance();
      await this.GetSchedule();
     
    } else {
      this.GoToLogin();
    }
  },
  methods: {
    GetAttendance() {
      this.Busy = true;
      this.$API
        .get(this.$ViewAttendanceStudent, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.Busy = false;
            this.attendance = response.data;
            this.FilteredAttendance = this.attendance;

            var gradeNames = _.uniq(_.map(response.data, "Grade"));
            gradeNames.sort(function (a, b) {
              return a.toLowerCase().localeCompare(b.toLowerCase());
            });
            this.gradeOptions = gradeNames;
            this.gradeOptions.unshift("ALL GRADE");

            var classNames = _.uniq(_.map(response.data, "Class"));
            classNames.sort(function (a, b) {
              return a.toLowerCase().localeCompare(b.toLowerCase());
            });
            this.classOptions = classNames;
            this.classOptions.unshift("ALL CLASS");

            var teacherNames = _.uniq(_.map(response.data, "Teacher"));
            teacherNames.sort(function (a, b) {
              return a.toLowerCase().localeCompare(b.toLowerCase());
            });
            this.teacherOptions = teacherNames;
            this.teacherOptions.unshift("ALL TEACHER");
             this.GetAttendanceReport();
          }
        });
    },
     GetAttendanceReport() {
      this.BusyReport = false;
      this.$API
        .get(this.$GetAttendanceReport, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
           this.Busy = false;
            this.attendanceReport = response.data;
          
          }
        });
    },
   
    ApplyFilter: function () {
      var arr = _.orderBy(this.attendance, ["Name"], ["asc"]);
      if (_.isEmpty(arr) == false) {
        const result = _.filter(arr, ({ SubjectName, Teacher }) =>
          _.some([
            _.includes(!SubjectName || SubjectName.toLowerCase(), [
              this.SearchQuery.toLowerCase(),
            ]),
            _.includes(!Teacher || Teacher.toLowerCase(), [
              this.SearchQuery.toLowerCase(),
            ]),
          ])
        );
        this.FilteredAttendance = result;
      }
    },
    FilteredData() {
      console.log("masuk");
      this.FilteredAttendance = this.attendance;

      if (this.selectedGrade !== "ALL GRADE")
        this.FilteredAttendance = _.filter(
          this.FilteredAttendance,
          (item) => item.Grade === this.selectedGrade
        );

      if (this.selectedClass !== "ALL CLASS")
        this.FilteredAttendance = _.filter(
          this.FilteredAttendance,
          (item) => item.Class === this.selectedClass
        );

      if (this.selectedTeacher !== "ALL TEACHER")
        this.FilteredAttendance = _.filter(
          this.FilteredAttendance,
          (item) => item.Teacher === this.selectedTeacher
        );
    },
    RefreshAttd() {
      this.GetSchedule();
    },
    OpenStudentAttendance(item) {
      this.SubjectId = item.SubjectId;
      this.ScheduleId = item.Id;
     // this.UpdateRefreshAttendance(this.scheduleId);
      this.GetSchedule(this.SubjectId, this.ScheduleId);
    
    },
    GetSchedule() {
      this.$API
        .get(this.$GetScheduleById + "?subjectId=" + this.SubjectId + "&scheduleId=" + this.ScheduleId, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.schedule = response.data;
            this.FilteredSchedule = this.schedule;
            this.AttendanceModal = true;
          }
        });
    },
   
    UpdateRefreshAttendance: function (scheduleId) {
      {
        this.scheduleId = scheduleId;
        const formData = new FormData();
        formData.append("scheduleId", this.scheduleId);

        return this.$API
          .post(this.$UpdateRefreshAttendance, formData, {
            withCredentials: true,
          })
          .then((response) => {
            if (response.status == 200) {
                this.GetSchedule();
            } else {
            }
          })
          .catch((error) => {
            this.Busy = false;
            this.Loading = false;
            this.Error = true;
            this.Message = error.response.data.message;
          });
      }
    },

    UpdateAttendStudent: function (item) {
     // this.AttendanceId = item.Id;
      this.ScheduleId = item.ScheduleId;
      this.ManualStudentId = item.ManualStudentId;
       this.UserId = item.UserId;

      const formData = new FormData();
      //formData.append("Id", this.AttendanceId);
      formData.append("ScheduleId", this.ScheduleId);
      formData.append("IsAttending", true);
       formData.append("ManualStudentId", this.ManualStudentId);
         formData.append("UserId", this.UserId);

      return this.$API
        .post(this.$UpdateStudentAttendance, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.RefreshDataStudent();
            //this.AttendanceModal = false;
            //this.$dialog.alert("Success save").then(function () {});
          } else {
            this.Busy = false;
            this.$dialog.alert("Error ").then(function () {});
          }
        })
        .catch((error) => {
          this.Busy = false;
          this.Loading = false;
          this.Error = true;
          this.Message = error.response.data.message;
        });
    },
    RefreshDataStudent()
    {
      this.GetSchedule();
    },
    CloseModal()
    {
      this.AttendanceModal = false;

    },
    UpdateNotAttendStudent: function (item) {
      this.AttendanceId = item.Id;
      this.ManualStudentId = item.ManualStudentId;
      this.ScheduleId = item.ScheduleId;
      const formData = new FormData();
      formData.append("ScheduleId", this.ScheduleId);
      formData.append("IsAttending", false);
      formData.append("ManualStudentId", this.ManualStudentId);

      return this.$API
        .post(this.$UpdateStudentAttendance, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
             this.RefreshDataStudent();
          } else {
            this.Busy = false;
            this.$dialog.alert("Error ").then(function () {});
          }
        })
        .catch((error) => {
          this.Busy = false;
          this.Loading = false;
          this.Error = true;
          this.Message = error.response.data.message;
        });
    },
    GenerateReport()
    {

    }
  },
};
</script>
<style>
.style-chooser .vs__open-indicator {
  fill: rgb(251 248 254);
  -webkit-transform: scale(1);
  transform: scale(1);
  -webkit-transition: -webkit-transform 150ms
    cubic-bezier(1, -0.115, 0.975, 0.855);
  transition: -webkit-transform 150ms cubic-bezier(1, -0.115, 0.975, 0.855);
  transition: transform 150ms cubic-bezier(1, -0.115, 0.975, 0.855);
  transition: transform 150ms cubic-bezier(1, -0.115, 0.975, 0.855),
    -webkit-transform 150ms cubic-bezier(1, -0.115, 0.975, 0.855);
  -webkit-transition-timing-function: cubic-bezier(1, -0.115, 0.975, 0.855);
  transition-timing-function: cubic-bezier(1, -0.115, 0.975, 0.855);
}
.style-chooser .vs__clear {
  fill: rgb(251 248 254);
  padding: 0;
  border: 0;
  background-color: transparent;
  cursor: pointer;
  margin-right: 8px;
}
.style-chooser .vs__dropdown-toggle {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  padding: 0 0 4px 0;
  background: none;
  border: 1px solid #009efb;
  border-radius: 4px;
  white-space: normal;
  height: 36px;
}
.style-chooser .vs__selected {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  background-color: #009efb;
  border: 1px solid #009efb;
  border-radius: 4px;
  color: #fff;
  line-height: 1.4;
  margin: 4px 2px 0px 2px;
  padding: 0 0.25em;
  z-index: 0;
}
.style-chooser .vs__single .vs__selected {
  background-color: #009efb;
  border-color: #009efb;
}
.custom-btn-blue {
  background: #009efb;
  border: 1px solid #009efb;
  color: #ffffff;
  border-radius: 4px;
}
.btn-act {
  display: inline-block;
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: #7460ee;
  border: 1px solid transparent;
  border-radius: 0.25rem;
}
.btn-primary {
  color: #fff;
  background-color: #7460ee;
  border-color: #7460ee;
}
.btn-primary:hover {
  color: #fff;
  background-color: #7460ee;
  border-color: #7460ee;
}
</style>
